const getTextContent = (content, el, callback) => {
    const textarea = document.createElement('textarea');
    let isError = false;

    textarea.value = content;

    // Avoid scrolling to bottom
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.position = 'fixed';
    textarea.style.zIndex = 99999;

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
        document.execCommand('copy');
    } catch (e) {
        console.error(e);
        isError = true;
    } finally {
        if (typeof callback === 'function') {
            callback(content, el, isError);
        }

        document.body.removeChild(textarea);
    }
};

let clickHandler = null;

export default {
    beforeMount(el, binding) {
        const {
            value,
            callback,
        } = binding.value;

        clickHandler = e => {
            const content = typeof value === 'undefined'
                ? e.target.textContent
                : value;

            getTextContent(content, el, callback);
        };

        el.addEventListener('click', clickHandler);
    },
    unmounted(el) {
        el.removeEventListener('click', clickHandler);
    },
};
